import { StyleSheet } from '@rexlabs/styling';
export default StyleSheet({
  wrapper: {
    display: 'flex',
    flexDirection: 'column'
  },
  container: {
    backgroundColor: 'white',
    border: '1px solid grey',
    background: 'white',
    padding: '0.25em',
    position: 'relative',
    borderRadius: 5,
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    cursor: 'text'
  },
  containerValid: {
    borderColor: 'green'
  },
  containerError: {
    borderColor: 'red'
  },
  containerFocused: {
    borderColor: 'deepskyblue',
    boxShadow: '0 0 5px deepskyblue'
  },
  containerTextArea: {
    position: 'relative',
    width: '100%',
    minWidth: '6em',
    flex: 1
  },
  disabled: {
    opacity: 0.6,
    filter: 'grayscale(100%)',
    cursor: 'default'
  },
  input: {
    fontSize: 'inherit',
    fontStyle: 'inherit',
    fontWeight: 'inherit',
    color: 'inherit',
    fontFamily: 'inherit',
    width: '100%',
    minWidth: '4em',
    border: 'none',
    padding: 0,
    margin: 0,
    flex: 1,
    backgroundColor: 'transparent',
    ':focus': {
      outline: ['none', 0]
    }
  },
  inputTextArea: {
    position: 'absolute',
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    height: '100%',
    resize: 'none',
    overflow: 'hidden'
  },
  inputTextAreaMirror: {
    display: 'block',
    minHeight: '4em',
    whiteSpace: 'pre-wrap',
    color: 'transparent',
    visibility: 'hidden',
    position: 'static'
  },
  cosmeticWrapper: {
    position: 'relative',
    flex: 1
  },
  cosmetic: {
    backgroundColor: 'transparent',
    position: 'absolute',
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    pointerEvents: 'none',
    zIndex: 1
  },
  charLimitContainer: {
    textAlign: 'right',
    width: '100%'
  },
  charLimitReached: {
    fontWeight: 'bold'
  },
  charLimitExceeded: {
    color: 'red'
  },
  prefix: {},
  suffix: {}
});